export default function displayMessageType(type) {
    let result = null;
    if (type === "contract") result = "Auftrag";
    else if (type === "consumption_point") result = "Lieferstelle";
    return result;
}
